import React from "react";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";

function Magistr() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Navbar />
      <div className="custom__page">
        <div className="container">
          <div className="header__custom">
            <h4>Magistratura bo’limi boshlig'i</h4>
            <div className="card__custom">
              <div className="box__custom">
                <img src="/img/umarovafiruza.jpg" alt />
              </div>
              <div className="box-1__custom">
                <p>Umarova Firuza Alisherovna </p>
                <span>Bo`lim boshlig`i</span>
                <br />
                <br />
                <hr />
                <div className="wer__custom">
                  <div className="malinki__custom">
                    <p>E-pochta</p>
                    <span>fira-umarova@yandex.ru </span>
                  </div>
                  <div className="malinki1__custom">
                    <p>Telefon nomer</p>
                    <span>+998 71 256-37-38</span>
                  </div>
                </div>
                <div className="wer__custom"></div>
              </div>
            </div>
          </div>
          <div className="card1__custom">
            <p>
              Magistratura bo’limi:
              <br />
              <br />
              Bo‘lim o‘z faoliyatini O‘zbekiston Respublikasi Prezidentining
              2017 yil 20-apreldagi “Oliy ta’lim tizimini yanada rivojlantirish
              chora tadbirlari to‘g‘risida”gi PQ-2909-son qarori hamda 2017-yil
              27-iyuldagi “Oliy ma’lumotli mutaxassislar tayyorlash sifatini
              oshirishda iqtisodiyot sohalari va tarmoqlarining ishtirokini
              yanada kengaytirish chora-tadbirlari
              tadbirlari  to‘g‘risida”gi  PQ-3151-son qarorlari asosida
              takomillashtirmoqda. Ularga asosan malaka talablari va o‘quv
              rejadagi fanlar tarkibi qaytadan ko‘rib chiqildi.  O‘zbekiston
              Respublikasi Vazirlar Mahkamasining 2007-yil 10-sentyabrdagi
              «O‘zbekiston Respublikasi oliy ta’lim tizimida magistratura
              faoliyatini takomillashtirish, uning samaradorligini oshirish
              chora-tadbirlari to‘g‘risida”gi 190-son Qarorining tasdiqlanishi
              Kadrlar tayyorlash milliy dasturidagi belgilangan vazifalarni
              samarali bajarilishiga qo‘yilgan qadam bo‘lib, Toshkent
              farmatsevtika institutida 2008-yil yanvar oyidan Magistratura
              bo‘limi tashkil etildi va unga rahbar etib f.f.n., dori turlari
              texnologiyasi kafedrasi dotsenti Nazirova Yayra Qosimovna
              tayinlandi. 2012-2018 yillar oralig’ida esa bo‘limga DTT
              kafedrasining dotsenti, farm.f.d. Sh.F.Iskandarova rahbarlik
              qildi. 2019 yil  8 fevraldan DVST kafedrasining dotsenti,
              farm.f.n. N.E.Mamatmusaeva rahbarlik qilmoqda.
              <br />
              <br />
              Bo‘lim o‘z faoliyatini quyidagi hujjatlarga asoslangan holda olib
              boradi O‘zbekiston Respublikasi Prezidentining 2012-yil
              24-iyuldagi PF – 4456-son “Oliy malakali ilmiy va ilmiy-pedagog
              kadrlar tayyorlash va attestatsiyadan o‘tkazish tizimini  yanada
              takomillashtirish to‘g‘risida”gi Farmoni ijrosini ta’minlash
              maqsadida O‘zbekiston Respublikasi Vazirlar Mahkamasining 2015-yil
              2-martdagi 36-son qaroriga asosan tasdiqlangan “Magistratura
              to‘g‘risidagi nizom” ; O‘zbekiston Respublikasi Oliy va o’rta
              maxsus ta’lim vazirligining 2018-yil 9 avgustdagi 19-2018-son
              buyrug’iga asosan “Oliy ta’lim muassasalarida talabalar bilimini
              nazorat qilish va baholash tizimi to’g’risidagi  nizom”;
              <br />
              <br />
              O‘zR Oliy va o‘rta maxsus ta’lim Vazirligining 2017-yilda
              tasdiqlangan mutaxassisliklar bo‘yicha DTSlari, 2017-yilda
              tasdiqlangan malakaviy talablar  va o‘quv rejalari;
              <br />
              <br />
              Toshkent farmatsevtika instituti  rektori tomonidan har bir o‘quv
              yili uchun tasdiqlangan Ishchi o‘quv rejalari.
              <br />
              <br />
              Bo‘lim faoliyatini tashkillashtirish quyidagi yo‘nalishlarda olib
              boriladi
              <br />
              Magistratura mutaxassisliklari uchun Davlat ta’lim standartlari va
              boshqa me’yoriy hujjatlarni ishlab chiqish, xodimlar
              buyurtmachilari talab va takliflari asosida ularni muntazam
              takomillashtirib borish;
              <br />
              Magistrlar tayyorlash bo‘yicha o‘quv jarayonini tashkil etish,
              ta’lim va o‘qitish sifatini nazorat qilish;
              <br />
              Magistratura faoliyatini boshqarish, ta’lim jarayonlarini tashkil
              etishning shakl va mexanizmlarini modernizatsiya qilish;
              <br />
              Magistratura mutaxassisliklarini zaruriy darsliklar va adabiyotlar
              bilan ta’minlashni nazorat qilish, bu ishga yetuk olimlar, yuqori
              malakali mutaxassislarni jalb etish, ilmiy sohani rivojlantirish
              kabi ishlarni tashkillashtirish;
              <br />
              Magistratura talabalari tomonidan ilmiy-tadqiqot va
              ilmiy-pedagogik  ishlani amalga oshirilishini nazorat qilish;
              <br />
              Institutning kafedralarida magistrlar tayyorlash bo‘yicha
              faoliyatni muvofiqlashtirish va nazorat qilish;
              <br />
              Magistratura talabalarini o‘zlashtirish, bitiruvchilarning ishga
              joylashish monitoringini olib borish, magistrlik
              dissertatsiyalarini tayyorlash va rasmiylashtirish  ishlarini
              muntazam ravishda tahlil qilish va ular yuzasidan hisobotlar
              tayyorlash;
              <br />
              Magistraturada dars berayotgan pedagog kadrlarga yuklatilgan
              vazifalarni amalga oshirishlari uchun maqsadga yo‘naltirilgan
              sharoitlarni yaratish va ularni ijtimoiy-kasbiy va shaxsiy
              faolligini oshirish, ularni rag‘batlantirish mexanizimlarini
              ishlab chiqish;
              <br />
              Magistratura mutaxassisliklari bo‘yicha axborot ta’minoti
              tizimlarini shakllantirish va rivojlantirish;
              <br />
              Respublikadagi va ilg‘or xorijiy hamkorlar bilan birgalikda
              ilmiy-ta’limiy loyihalar va dasturlarni ishlab chiqish hamda
              amalga oshirish ishlarida ishtirok etish;
              <br />
              Mavjud holatini tizimli ravishda tahlil qilish, aniqlash, muammoli
              holatlarni aniqlash, magistraturani rivojlantirish tendensiyalari
              bo‘yicha ustuvor yo‘nalishlarni aniqlash;
              <br />
              Magistratura mutaxassisliklari bo‘yicha talab va takliflarni
              o‘rganishini tashkil etish, ta’lim xizmatlari va kasbiy mehnat
              bozorida raqobatbardoshligini ta’minlash hamda magistrlar
              tayyorlash sohasida marketingni shakllantirish;
              <br />
              Byudjet asosida ta’lim olgan magistratura talabalarini ishga
              taqsimlash borasida mehnat bozoridagi ish o‘rinlari to‘g‘risida
              axborot bankini yaratish, ish beruvchi tashkilotlar bilan
              hamkorlik aloqalarini rivojlantirish;
              <br />
              Magistrlar tayyorlash jarayoni ishtirokchi-hamkorlari qiziqishlari
              aks etgan taklif va ko‘rsatmalarni ishlab chiqish, shuningdek,
              magistratura mutaxassisliklariga qo‘yilgan vazifalardan kelib
              chiqib, uni rivojlantirishga qaratilgan dasturlar, loyihalar,
              tashabbuslar tuzish amalga oshirildi.
              <br />
              <br />
              Toshkent farmatsevtika institutida  talabalar quyidagi
              mutaxassisliklar bo‘yicha ta’lim olishadi
              <br />
              <br />
              70910701- Farmatsevtik kimyo va farmakognoziya
              <br />
              70910702 - Farmatsevtika ishini tashkil qilish va boshqarish
              <br />
              70710104- Dorivor vositalar va preparatlar texnologiyasi
              <br />
              70910703- Eksperimental va sport farmakologiyasi
              <br />
              70910802- Dorilarning sanoat texnologiyasi
              <br />
              70911001- Farmtеsevtikada sifatni ta’minlash va sifat nazorati
              <br />
              70910901- Farmatsevtik biotexnologiya va bioinjineriya
              <br />
              70910801 - Dorivor o‘simliklar biotexnologiyasi
              <br />
              <br />
              2012-yildan boshlab bitiruvchi magistratura
              talabalarining  dissertatsiyalari ingliz tilida himoya qilishlari
              joriy etildi.
              <br />
              <br />
              Diqqatga sazovor yutuqlardan yana biri institutning magistratura
              ta’lim tizimi bo‘yicha xalqaro integratsiya bo‘yicha samarali
              faoliyat yuritayotganligidir. Institutning bir nechta yaqin va
              uzoq xorijiy davlatlari bilan hamkorligi yo‘lga qo‘yilgan. Bular
              jumlasiga Ukraina, Rossiya Federatsiyasi, Janubiy Koreya,
              Qozog’iston va boshqalarni kiritish mumkin.
              <br />
              <br />
              Hozirgi kunda 2 nafar magistratura bitiruvchilari Janubiy
              Koreyaning Chungbuk Milliy universitetida PhD ilmiy darajasini
              olish uchun ta’lim olishmoqda. 2017-2021 yillarda oliy ta’lim
              tizimini kompleks rivojlantirish dasturi loyihasiga tegishli
              takliflarni tayyorlash maqsadida magistratura talabalari qatoridan
              3 nafari chet el oliy ta’lim muassasalarida PhD ilmiy darajasini
              olish uchun o‘qishga jo‘natilishi tavsiya qilindi.
              <br />
              <br />
              Undan tashqari 2021- yilning 13-26 dekabr kuiari S.D.Asfendiyarov
              nomidagi Qozog'iston milliy tibbiyot universitetiga Eksperimental
              va sport farmakologiya yo'nalishi 1-2-kurs magistrantlari
              Muydinova Dilafruz Dilshodbek qizi va Bekmurzayeva Nuijamal
              Bakhtiyarovnalar, OTM lar o'rtasidagi tuzilgan memorandum asosida
              talabalar aimashuvi dasturi amalga oshirildi.
              <br />
              <br />
              O‘zbekiston Respublikasi Vazirlar Mahkamasining 2007-yil
              10-sentyabrdagi 190-son “O‘zbekiston Respublikasi oliy ta’lim
              tizimida magistratura faoliyatini yanada takomillashtirish, uning
              samaradorligini oshirish chora-tadbirlari to‘g‘risida” qarori
              ijrosi yuzasidan magistratura mutaxassisliklari talabalari va
              ularni tayyorlash bilan band bo‘lgan pedagog kadrlarning malaka
              darajasini baholashga oid test sinovlari Davlat test markazi
              tomonidan 2015-yildan buyon muntazam ravishda o‘tkazilib
              kelinmoqda. Ushbu sinovlarda bizning institutimiz doimo eng yuqori
              kursatkichlarga erishib kelganligi quvonarli. Masalan, 2015-yilda
              olingan ma’lumotlarga ko‘ra Toshfarmi 1 –o‘rinda bo‘lgan,
              2016-yilning noyabr oyida o‘tkazilgan sinovlar
              natijasida  mutaxassislik fanidan institut talabalarining
              ko‘rsatkichi 100% ni tashkil qildi. Shuningdek, Davlat test
              markazi tomonidan yuborilgan 2015 va 2016 o‘quv yillaridagi
              solishtirma jadval asosida barcha fanlardan o‘zlashtirish
              ko‘rsatkichi oshgani ma’lum bo‘ldi.
              <br />
              <br />
              Institutda bajarilgan Magistrlik dissertatsiyalari bo‘yicha ilmiy
              maqola va tezislar chop etildi. Magistratura talabalari o‘z ilmiy
              tadqiqotlari natijalari bilan institutda va tegishli OTM va ITI
              lar tomonidan o‘tkazilgan ilmiy-amaliy anjumanlarda faol ishtirok
              etmoqda.
            </p>
          </div>
        </div>
        <div className="mt"></div>
      </div>
      <Footer />
    </div>
  );
}

export default Magistr;
